import request from '@/utils/request'

/** 登录api */
export const loginApi = (data) => request.post('/login', data)
/** 退出 */
export const logoutApi = () => request.post('/user/logout')


